import { FixedZoomify, type ZoomifyOptions } from "./FixedZoomify.osd";

type ZipZoomifyIndex = { [key: string]: [number, number] }

export class ZipZoomify extends FixedZoomify {
	private index: ZipZoomifyIndex = {};
	
	constructor(options: ZoomifyOptions) {
		super(options);

		this.ready = false;
		this.getImageInfo(this.tilesUrl + '.index');
	}
	
	async getImageInfo(url: string) {
		try {
			const response = await fetch(url);
			let blob = await response.blob();
			
			// Check if file is gzip compressed and decompress if necessary
			const magicBytes = new Uint8Array(await blob.slice(0, 2).arrayBuffer());
			if (magicBytes[0] === 0x1f && magicBytes[1] === 0x8b) {
				const ds = new DecompressionStream("gzip");
				const decompressedStream = blob.stream().pipeThrough(ds);
				blob = await new Response(decompressedStream).blob();
			}
			const data = await blob.text();
			
			// parse index file ("0-0-0 85 28842" => "[level]-[x]-[y] [relative byte offset] [length]"
			let offset = 0;
			this.index = (data.split('\n')).reduce<Record<string, [number, number]>>((map, e, i) => {
				const parts = e.split(' ');
				const relativeOffset = Number(parts[1]);
				const length = Number(parts[2]);
				offset += relativeOffset;
				map[parts[0]] = [offset, length]
				offset += length
				return map;
			}, {})
			this.ready = true;
			this.raiseEvent('ready', { tileSource: this });
		} catch (err) {
			this.raiseEvent('open-failed', {
				message: err,
				source: url
			});
		}
	}
	
	supports(data: { type: string | undefined }, url: string) {
		return (data.type && "zipzoomifytileservice" == data.type);
	}
	
	getTileAjaxHeaders(level: number, x: number, y: number) {
		const part = this.index[`${level}-${x}-${y}`];
		if (part) {
			return {
				'Range': `bytes=${part[0]}-${part[0] + part[1]}`,
			}
		}
        return null;
	}
	
	getTileUrl(level: number, x: number, y: number) {
		const part = this.index[`${level}-${x}-${y}`];
		if (part) {
			return this.tilesUrl;
		} else {
            // Return a dummy url to prevent OpenSeadragon from trying to load the tile
			return "https://";
		}
	}
}